import type { TransactionType, TransactionsSortingValue } from 'types/api/transaction';
import type { SelectOption } from 'ui/shared/select/types';

export const TXS_HEADER_KEYS = {
  hash: 'txs.txnHash',
  dateTime: 'txs.dateTime',
  fromTo: 'txs.fromTo',
  amount: 'txs.amount',
  tokenAddress: 'txs.tokenAddress',
  method: 'common.method',
  valueUsd: 'txs.valueUsd',
  fee: 'txs.txnFee',
} as const;

export const TX_TYPE_KEY_MAP: Record<TransactionType, string> = {
  blob_transaction: 'txs.blobTxn',
  rootstock_remasc: 'txs.remasc',
  rootstock_bridge: 'txs.bridge',
  token_creation: 'txs.tokenCreation',
  contract_creation: 'txs.contractCreation',
  token_transfer: 'txs.tokenTransfer',
  contract_call: 'txs.contractCall',
  coin_transfer: 'txs.coinTransfer',
};

export const SORT_OPTION_KEYS: Array<SelectOption<TransactionsSortingValue> & { labelKey: string }> = [
  { label: 'Default', labelKey: 'common.default', value: undefined },
  { label: 'Value ascending', labelKey: 'txs.valueAscending', value: 'value-asc' },
  { label: 'Value descending', labelKey: 'txs.valueDescending', value: 'value-desc' },
  { label: 'Fee ascending', labelKey: 'txs.feeAscending', value: 'fee-asc' },
  { label: 'Fee descending', labelKey: 'txs.feeDescending', value: 'fee-desc' },
  { label: 'Block number ascending', labelKey: 'txs.blockNumberAscending', value: 'block_number-asc' },
];
